// eslint-disable-next-line
const local: any = {
    API_BASE_URL: 'https://dev-edge.biocertica.com',
    SSO_APP_URL: 'http://localhost:3000',
    PRACTITIONERS_APP_URL: 'http://localhost:3005',
    AMPLITUDE_API_KEY: '582a22965d0f5145041e315df5dac534',
    MAPS_API_KEY: 'AIzaSyBlFMW-gJrGMSXbaVUChV0Ny6vWAjSnxCo',
};

// eslint-disable-next-line
const development: any = {
    API_BASE_URL: 'https://dev-edge.biocertica.com',
    SSO_APP_URL: 'https://dev-accounts.biocertica.com',
    PRACTITIONERS_APP_URL: 'https://dev-portal.biocertica.com/',
    AMPLITUDE_API_KEY: '582a22965d0f5145041e315df5dac534',
    MAPS_API_KEY: 'AIzaSyBlFMW-gJrGMSXbaVUChV0Ny6vWAjSnxCo',
};

// eslint-disable-next-line
const production: any = {
    API_BASE_URL: 'https://edge.biocertica.com',
    SSO_APP_URL: 'https://accounts.biocertica.com',
    PRACTITIONERS_APP_URL: 'https://portal.biocertica.com/',
    AMPLITUDE_API_KEY: 'f8e893623fada807d0b3025f57108942',
    MAPS_API_KEY: 'AIzaSyBlFMW-gJrGMSXbaVUChV0Ny6vWAjSnxCo',
};

const config =
    process.env.REACT_APP_BUILD_TARGET === 'PRODUCTION'
        ? production
        : process.env.REACT_APP_BUILD_TARGET === 'DEVELOPMENT'
        ? development
        : local;

export default {
    DEFAULT_LANGUNAGE: 'en',
    CONTACT_MAIL: 'info@biocertica.com',
    ...config,
};
